<script setup lang="ts">

</script>

<template>
    <NuxtImg src="/images/logo-dark.svg" alt="Logo" class="h-auto w-full max-w-[140px] lg:max-w-[170px]"/>
</template>

<style scoped>

</style>
